import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import Translate from '../../../../../components/translate/Translate';
import {requireImage} from '../../../../../utils/utils';

import './styles.scss';

export interface IMainCameraPreApprovalProps {
    dir: 'ltr' | 'rtl';
    getPreCameraApprovalImage: () => string;
}

@observer
export class MainCameraPreApproval extends TechseeBaseComponent<IMainCameraPreApprovalProps> {
    renderInternal(): JSX.Element {
        const {dir, getPreCameraApprovalImage} = this.props;
        const imagePath = getPreCameraApprovalImage();

        return (
            <div className='wizard-container camera-pre-approval' dir={dir}>
                <div className='heading-container'>
                    <div>
                        <Translate text='MAIN.VIEW.CAMERA_PREAPPROVAL-LINE-1' />
                    </div>
                    <div>
                        <Translate text='MAIN.VIEW.CAMERA_PREAPPROVAL-LINE-2' />
                    </div>
                </div>
                <div className='image-container'>
                    <div className='image-wrapper'>
                        <img src={requireImage(imagePath)} alt='camera pre-approval' />
                    </div>
                </div>
            </div>
        );
    }
}
